import iziToast from "izitoast";

import "izitoast/dist/css/iziToast.min.css";

import { getImagesByQuery } from "./js/pixabay-api";
import { createGallery, clearGallery, showLoader, hideLoader, showLoadMoreButton, hideLoadMoreButton } from "./js/render-functions";

const form = document.querySelector(".form");
const searchInput = document.querySelector(`input[name="search-text"]`);
const loadMore = document.querySelector(".btn-load-more");

const PER_PAGE = 15;

let page = 1;
let currentQuery = "";

loadMore.addEventListener("click", onLoadMore);
form.addEventListener("submit", handleSubmit);

async function handleSubmit(event) {
    event.preventDefault();
    clearGallery();
    showLoader();
    hideLoadMoreButton();
    const searchText = searchInput.value.trim();
    currentQuery = searchText;
    page = 1;
    event.target.reset();
 
    if (searchText.length === 0) {
        iziToast.show({
                    message: 'Sorry, there are no images matching your search query. Please try again!',
                    color: 'red',
                    position: 'topRight',
        });
        hideLoader();
        hideLoadMoreButton();
        return;
    }
    try {
        const data = await getImagesByQuery(searchText, page);

        if (data.hits.length === 0) {
        iziToast.show({
            message: 'Sorry, there are no images matching your search query. Please try again!',
            color: 'red',
            position: 'topRight',
        });

        return;
    }

    createGallery(data.hits);

    if (page * PER_PAGE >= data.totalHits) {
        hideLoadMoreButton();

        iziToast.show({
            message: "We're sorry, but you've reached the end of search results.",
            position: 'topRight',
            color: 'blue',
        });

    } else {
        showLoadMoreButton();
    }
        
   } catch(error) {
            iziToast.show({
                message: 'Something went wrong!',
                color: 'red',
            });
            console.log(error);
    } finally {
        hideLoader();
        }
}

async function onLoadMore() {
    page++;

    showLoader();
    hideLoadMoreButton();

    try {
        const data = await getImagesByQuery(currentQuery, page);
        createGallery(data.hits);

        if (page * PER_PAGE >= data.totalHits) {
         hideLoadMoreButton();

        iziToast.show({
          message: "We're sorry, but you've reached the end of search results.",
          position: 'topRight',
          color: 'blue',
          });
            } else {
            showLoadMoreButton();
        }
        
        const card = document.querySelector(".gallery-item");

        if (card) {
           const cardHeight = card.getBoundingClientRect().height;

            window.scrollBy({
            left: 0,
            top: cardHeight * 2,
            behavior: "smooth",
        }) 
        }
        
    } catch (error) {
        iziToast.show({
                message: 'Something went wrong!',
                color: 'red',
            });
            console.log(error);
    } finally {
        hideLoader();
    }
}